import { WidgetType } from '../..'
import { DOMUtils } from '../../../../utils/dom'
import { AbstractWidgetAdapter, IWidgetAdapter } from '../adapter'

export class Distroscale extends AbstractWidgetAdapter implements IWidgetAdapter {
    public static DOM = {
        attrs: {
            key: 'data-distroscale-htmlid'
        }
    }

    /**
     * Load 3rd party javascript with widget data
     */
    public loadData(): void {
        const accountId = this.el.getAttribute(Distroscale.DOM.attrs.key)
        const hasScript = DOMUtils.idElementExists(WidgetType.DISTROSCALE)
        const scriptSrc = `//c.jsrdn.com/s/cs.js?p=${accountId}`

        // only load the script if there is a account Id and script isn't present on the page
        if (accountId && !hasScript) {
            DOMUtils.loadScript(scriptSrc, [{
                    key: DOMUtils.attrs.id,
                    value: WidgetType.DISTROSCALE
                }])
        }
    }

    /**
     * Remove distroscale video player within the story content
     */
    public removeWidgetContainer(): void {
        DOMUtils.nodes(document.querySelectorAll(`.js-widget-${WidgetType.DISTROSCALE}`))
        .forEach((el: Element) => el.remove())
    }
}
